/**
 * Het inzicht dat bij een cel hoort, of null.
 *
 * Een cel (celtype + parameters) heeft hooguit één levend inzicht: het
 * concept dat ervan gemaakt is, of de publicatie. De opgeslagen `Params`
 * dragen ook de server-side ingevulde defaults (`limit`), dus de vergelijking
 * gaat één kant op: alles wat het voorstel noemt moet in het inzicht staan.
 * Een voorstel zonder segment matcht daarom niet op een gesegmenteerd
 * inzicht — dat is een andere uitspraak.
 *
 * Gepubliceerd gaat vóór concept; afgewezen en zacht verwijderd tellen niet,
 * daar hoort geen knop naartoe.
 *
 * @param {Array<object>} insights - QuestionInsights-documenten van het thema
 * @param {{cellType: string, params: object}} voorstel
 * @returns {object|null}
 */
const insightForCell = (insights, voorstel) => {
    const params = voorstel.params || {}
    const sleutels = Object.keys(params)
    const segmentVerwacht = params.segment !== undefined && params.segment !== null && params.segment !== ''
    const past = (insight) => {
        if (!insight || insight.Deleted === true) return false
        if (insight.Status !== 'published' && insight.Status !== 'draft') return false
        if (insight.CellType !== voorstel.cellType) return false
        const opgeslagen = insight.Params || {}
        if (!sleutels.every((k) => opgeslagen[k] === params[k])) return false
        const opgeslagenSegment = opgeslagen.segment !== undefined && opgeslagen.segment !== null && opgeslagen.segment !== ''
        return segmentVerwacht === opgeslagenSegment
    }
    const kandidaten = insights.filter(past)
    return kandidaten.find((i) => i.Status === 'published') || kandidaten[0] || null
}

export default insightForCell
